import { render } from "./product-group-list.vue?vue&type=template&id=5d2ef515"
import script from "./product-group-list.vue?vue&type=script&lang=js"
export * from "./product-group-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__